import { useTranslation } from 'react-i18next';

import { Card } from '@/components/ui/Card';
import { Spinner } from '@/components/ui/Spinner';
import { Button } from '@/components/ui/Button';
import {
  useRefreshTrustPassport,
  useTrustPassport,
} from '@/hooks/useTrustPassport';
import { formatDate } from '@/utils/format';

export function TrustPassportPage() {
  const { t } = useTranslation();
  const tp = useTrustPassport();
  const refresh = useRefreshTrustPassport();

  if (tp.isLoading) return <Spinner />;

  return (
    <Card title={t('trust_passport.title')}>
      {tp.data ? (
        <>
          <p className="text-4xl font-semibold text-brand">{tp.data.score ?? '—'}</p>
          <p className="mt-2 text-sm text-slate-600">
            {t('trust_passport.lease_history')}: {tp.data.lease_history_count ?? 0}
          </p>
          <p className="text-sm text-slate-600">
            {t('trust_passport.on_time_rate')}:{' '}
            {tp.data.on_time_payment_rate
              ? `${(tp.data.on_time_payment_rate * 100).toFixed(0)}%`
              : '—'}
          </p>
          {tp.data.last_check_at ? (
            <p className="mt-2 text-xs text-slate-400">
              {t('trust_passport.last_check', { date: formatDate(tp.data.last_check_at) })}
            </p>
          ) : null}
          <div className="mt-4">
            <Button onClick={() => refresh.mutate()} loading={refresh.isPending}>
              {t('trust_passport.refresh')}
            </Button>
          </div>
        </>
      ) : (
        <p className="text-sm text-slate-500">{t('web.empty.no_data')}</p>
      )}
    </Card>
  );
}
